export enum Themes {
  Default = '',
  Dark = 'dark',
}
